import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Navbar, NavbarBrand } from 'reactstrap';
import ImageHelper from '../../helpers/ImageHelper';
import Header from '../shared/Header';
import NotificationIcon from '../shared/notifications/NotificationIcon';

class TopHeader extends Component {

  render() {
    const card_outline = this.props.locationSettings.card_outline_enable === 1 ? 'card-outline-color' : 'card-outline-color-hide';
    return (
      <div className="box-shadow">
        <Navbar className={`nav-logo justify-content-between ps-3 primary-color`} light expand="md">
          {this.props.isBack && (
            <Header text={this.props.text} icon={faArrowLeft} goBack={this.props.goBack} />
          )}
          <NavbarBrand href={`/${this.props._location?.slug}`}>
            {!this.props.isBack &&
              this.props.locationSettings &&
              this.props.locationSettings.logo && (
                <img
                  src={ImageHelper.getImageURL(
                    this.props.locationSettings.logo,
                    '?func=cover&h=120'
                  )}
                  height="60"
                  alt={this.props._location.name}
                ></img>
              )}
          </NavbarBrand>
          {this.props._location?.layout !== 'old' ? <NotificationIcon /> : null}
        </Navbar>
      </div>
    );
  }
}
function mapStateToProps(state) {
  const { locationSettings } = state;
  return { locationSettings };
}
export default connect(mapStateToProps)(TopHeader);
